




















































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import Swiper, { SwiperOptions } from 'swiper';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';
import IntersectionDirective from '../../common/vue/intersection-directive';
import Store from './Store';

const GridProps = Vue.extend({
  props: {
    dataAnalyticsContentMilestone: Number,
    tabTitle: String,
    tabIcon: String,
    backgroundColor: String,
    showMore: Boolean,
    editMode: Boolean,
  },
});

@Component({
  directives: {
    intersect: IntersectionDirective,
  },
})
export default class Grid extends mixins(GridProps, ResizeUpdateMixin) {
  private readonly CLASS_BUTTON_SHOW_MORE = '.brandhub-more';

  swiperOptions: SwiperOptions = {
    freeMode: true,
    initialSlide: 1,
    slideToClickedSlide: true,
    slidesPerView: 'auto',
    centeredSlides: true,
  }

  swiper: Swiper | null = null;

  $refs!: {
    swiper: HTMLElement;
  };

  visible = false;
  isIntersecting = false;
  initialized = false;
  isFirstGrid = true;
  hasShowMoreItems = false;
  itemsVisible = 0;
  tabs: Grid[] = [];

  get rootClasses () {
    return {
      'brandhub-grid--edit-mode': this.editMode,
      'brandhub-grid--background-white': this.backgroundColor === 'inverted',
    };
  }

  get grids () {
    return Store.getters.grids;
  }

  onShowMore () {
    Array
      .from(this.$el.querySelectorAll(this.CLASS_BUTTON_SHOW_MORE))
      .forEach((item, index) => {
        if (index <= 5) {
          item.classList.remove('brandhub-more');
          this.itemsVisible += 1;
        }
      });
    this.hasShowMoreItems = this.$el.querySelectorAll(this.CLASS_BUTTON_SHOW_MORE).length > 0;
    TrackingPushService.getInstance().pushTrackingAttributes('link', 'button-click', 'show more');
  }

  activateButton (index: number) {
    const clickedButton = Array.from(this.$el.querySelectorAll('button'))[index];
    if (clickedButton) {
      clickedButton
        .classList
        .add('brandhub-thumb-tabs-btn-active');
    }
  }

  buttonClick (index: number) {
    Array
      .from(this.$el.querySelectorAll('button'))
      .forEach((item) => {
        item.classList.remove('brandhub-thumb-tabs-btn-active');
      });
    this.activateButton(index);
    this.tabs.forEach((grid: Grid) => {
      grid.visible = false;
    });
    this.tabs[index].visible = true;
    if (this.tabs[index].itemsVisible) {
      this.tabs[index].revealShowMore(this.tabs[index].itemsVisible);
    }
    TrackingPushService.getInstance().pushTrackingAttributes('link', 'grid tab', this.tabs[index].tabTitle);
    if (this.isMobile && this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  revealShowMore (count: number) {
    setTimeout(() => {
      Array
        .from(this.$el.querySelectorAll(this.CLASS_BUTTON_SHOW_MORE))
        .forEach((item, itemIndex) => {
          if (itemIndex < count) {
            item.classList.remove('brandhub-more');
          }
        });
    }, 10);
  }

  onResizeEnd () {
    if (!this.isFirstGrid) {
      return;
    }
    if (this.isMobile && this.tabs.length > 2) {
      this.initSwiper();
    } else if (this.initialized && this.swiper) {
      this.swiper.destroy();
    }
  }

  initSwiper () {
    this.swiper = new Swiper(this.$refs.swiper, this.swiperOptions);
    this.initialized = true;
  }

  setUpTracking () {
    Array
      .from(this.$el.querySelectorAll('.brandhub-thumb-item'))
      .forEach((item) => {
        item.addEventListener('click', () => {
          const headline = item.querySelector('.brandhub-thumb-item-headline')?.textContent || '';
          const href = item.querySelector('a')?.href;
          TrackingPushService.getInstance().pushTrackingAttributes('link', 'grid item', headline.trim().toLocaleLowerCase(), href?.trim());
        });
      });
  }

  fillParentClass () {
    Array
      .from(this.$el.querySelectorAll('[data-fill-parent-class]'))
      .forEach((item) => {
        const element = item as HTMLElement;
        const classes = element.dataset.fillParentClass;
        if (element.parentElement && classes) {
          element.parentElement.classList.add(classes);
          element.parentElement.classList.add('view');
        }
      });
  }

  created () {
    Store.commit('addGrid', this);
  }

  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.isFirstGrid = Store.getters.firstGrids.includes(this);
        if (this.isFirstGrid) {
          setTimeout(() => {
            this.hasShowMoreItems = this.$el.querySelectorAll(this.CLASS_BUTTON_SHOW_MORE).length > 0;
            this.activateButton(0);
            this.onResizeEnd();
            this.setUpTracking();
          }, 1000);
          this.visible = true;
        }
      }, 1000);
      if (this.editMode) {
        setInterval(() => {
          // Fills the grid item classes to the edit wrapper
          this.fillParentClass();
        }, 100);
      }
    });

    this.$on('resizeEnd', this.onResizeEnd);
  }
}
